import React from "react";
import { useAppSelector } from "../../../../../../app/hooks";
import { useMyProfileQuery } from "../../../../../../services/profileService/profile-api";
import { Alert, Button, Snackbar } from "@mui/material";
import { VariancePostCommand } from "../../../../../../services/varianceService/commands/VariancePostCommand";
import { ApprovalRounded } from "@mui/icons-material";
import {
  useVariancePendingApproveMutation,
  useVarianceSaveMutation,
} from "../../../../../../services/varianceService/variance-api";
import { useNavigate } from "react-router";
import { VariancePendingApprovalPostCommand } from "../../../../../../services/varianceService/commands/VariancePendingApprovalPostCommand";

type ownProps = {
  setNotify: Function;
  setMessage: Function;
};

function VariancePendingApproveBtn(props: ownProps) {
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const [varianceSave] = useVarianceSaveMutation();
  const [saveStatus, result] = useVariancePendingApproveMutation();
  const profile = useMyProfileQuery();
  const command = new VariancePendingApprovalPostCommand(incident?.id, profile.data?.identity!, profile.data?.email!);
  const isCurrentUserClosed = incident.assignedUsers.some((p) => p.upn === profile.data?.upn && p.isClosed);
  const isAnyUserClosed = incident.assignedUsers.some((p) => p.isClosed);
  const isDisabled = isCurrentUserClosed || isAnyUserClosed;
  const navigate = useNavigate();
  
  const handleApprove = async () => {
    try {
      await varianceSave(new VariancePostCommand(incident)).unwrap();
      await saveStatus(command).unwrap();
      props.setNotify(true);
      props.setMessage("Incident Submitted for Approval");
      setTimeout(() => {
        navigate(-1);
      }, 3000);
    } catch (error) {
      console.error('Failed to submit for approval:', error);
    }
  };
  
  return (
    <React.Fragment>
      <Button
        variant="outlined"
        color="success"
        startIcon={<ApprovalRounded />}
        onClick={() => handleApprove()}
        disabled={isDisabled}
      >
        {isAnyUserClosed && !isCurrentUserClosed ? "Not Needed" : "Submit"}
      </Button>

      <Snackbar open={result.isError}>
        <Alert color="error">
          {"An error has occured: " + JSON.stringify(result.error)}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}

export { VariancePendingApproveBtn };
